/**
 * @gonzovnc/protocol — the single source of truth for every GonzoVNC wire contract
 * consumed by the relay API and the web client. The JSON Schema files under
 * protocol/schemas/ are authoritative; these zod mirrors are proven to agree by the
 * three-way contract test suite (§10.5). The Swift Host mirrors the same fixtures.
 */
export { PROTOCOL_VERSION } from './version.js';
export * from './mods.js';
export * from './datachannel.js';
export * from './api.js';
export * from './keymap.js';
export { decodeTopic, encodeJson } from './decode.js';
/** Reserved participant identity for the Host (§6.13). */
export const HOST_IDENTITY = 'host';
/**
 * LiveKit participant-attribute keys the API stamps (§3.4, §6.4).
 * NOTE: keys MUST be dot-free. LiveKit silently camelCases dotted attribute keys on
 * storage (e.g. `gv.ctlEpoch` → `gvCtlEpoch`), which broke the host/client epoch read
 * and rejected all control input as `not-controller`. Keep these LiveKit-safe.
 */
export const ATTR = {
    ROLE: 'role',
    ADMIN: 'admin',
    CTL_EPOCH: 'gvCtlEpoch',
    CTL: 'gvCtl',
    DISPLAYS: 'displaysV1',
};
//# sourceMappingURL=index.js.map